<template>
      <div class="page-body">
  
    <PageTitle title="Dashboard" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row size-column">
          <button @click="generateQRCodes();">Generate</button>
             <button @click="downloadAsZip">Download All as ZIP</button>
         <div>
            <div v-for="record in treereports" :key="record.id" class="qr-container">
              <canvas :id="'qrCanvas-' + record.id"></canvas>
            </div>
          </div>
  </div>
  </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import axios from 'axios';

export default {
  name: "GenerateLabeledQRCodes",
  data() {
    return {
          treereports: [],
      records: [
        {
          iddate: "W8",
          name: "Vishwas Ganpati Lokhande",
          address: "Kumbhar Galli",
          ward: "8",
          property: "578",
          tank_lat: "16.9184874200708",
          tank_lng: "73.9300428025063",
          establishment: "Individual House",
          sanitation: "Septic Tank with Soak Pit",
          powered_by: "PRAPANCH",
        },
        // Add more records as needed
      ],
    };
  },
  mounted() {
    this.getBasics();
  },
  methods: {
         async getBasics() {
            var self = this;
            await  axios.post('getTankSurveyReport').then(function (response) { 
                 self.treereports = response.data.survey_report; 
                
                window.scrollTo(0, 0);
            }).then(()=>{
             //  self.generateQRCodes();
            });
        },
        
    async generateQRCodes() {
      const width = 288; // 3 inches
      const height = 336; // 3.5 inches

      for (const record of this.treereports) {
        const canvas = document.getElementById(`qrCanvas-${record.id}`);
        
        const context = canvas.getContext("2d");

        // Set canvas size
        canvas.width = width;
        canvas.height = height;

        // Prepare QR data
        const qrText = `
Ward No: ${record.ward}
Name: ${record.name}
Address: ${record.address}
Property No: ${record.property}
Tank Latitude: ${record.tank_location_lat}
Tank Longitude: ${record.tank_location_lng}
Establishment: ${record.establishment}
Sanitation Tank Type: ${record.sanitation}
Powered by: ${record.powered_by}
`;

        // Generate QR code on a separate canvas
        const qrCanvas = document.createElement("canvas");
        await QRCode.toCanvas(qrCanvas, qrText, {
          width: 272, // QR code width
          margin: 2,
        });

        // Draw QR code in the main canvas
        context.fillStyle = "white"; // Light background color
        context.fillRect(0, 0, width, height);
        context.drawImage(qrCanvas, 5, 5); // Center the QR code (69px margin for 288px width)

        // Add Labels Below QR Code
        context.fillStyle = "#000";
        context.font = "bold 14px Arial";
        context.textAlign = "center";
        
        var top_for_line=290;
        context.fillText(`W${record.ward} : ${record.name}`, width / 2, top_for_line); // First line
        context.fillText(`${record.address}`, width / 2, top_for_line+20); // Second line
        context.fillText(`Powered by: PRAPANCH`, width / 2, top_for_line+40); // Fourth line
      }
    },
   async downloadAsZip() {
     const zip = new JSZip();
    alert("Downloading...");
     for (const record of this.treereports) {
       const canvas = document.getElementById(`qrCanvas-${record.id}`);
       const imageData = canvas.toDataURL("image/png"); // Get image data in PNG format
       const base64Data = imageData.split(",")[1]; // Remove the "data:image/png;base64," part
       zip.file(`${record.iddate}_${record.name}.png`, base64Data, { base64: true }); // Add to ZIP
     }

     // Generate ZIP file and trigger download
     const zipBlob = await zip.generateAsync({ type: "blob" });
     saveAs(zipBlob, "QRCodes.zip");
   },
  },
};
</script>

<style>
.qr-container {
  margin-bottom: 20px;
}
canvas {
  border: 1px solid #ccc;
}
</style>